/* eslint-disable no-param-reassign */
import axios from 'axios';
import { API_BASE_URL } from 'constants/apiConf';
import { SAP_CONSUMER_ORIGIN } from 'constants/common';
import { URLS } from 'modules/session/repository';
import { ROUTE_PATH } from 'routes';
import platform from 'utils/platform';

const formatMessageError = (error) => {
  return {
    statusCode: error?.response?.status || 400,
    data: {
      status: error?.response?.data?.status || 'ERROR',
      error: error.response?.data?.error || true,
    },
    rawData: error?.response?.data || {},
  };
};

const ApiFetch = (baseURL, { skipOrigin = false } = {}) => {
  if (!baseURL) {
    // eslint-disable-next-line no-param-reassign
    baseURL = API_BASE_URL;
  }
  const instance = axios.create({
    baseURL,
    withCredentials: true,
  });

  instance.interceptors.request.use((config) => {
    // When running in a browser (not the native WebView), identify the caller as
    // PORTAL so the backend uses the PORTAL SAP user/branch and paymentId prefix
    // (PWS/PW) instead of APP (APS/AP). The native app stays as APP (backend
    // default, no param sent). CMS instances opt out via `skipOrigin` so the web
    // reads the same origin-agnostic content as the app (WEB_MLS-779).
    if (platform.isWeb && !skipOrigin) {
      config.params = { ...config.params, origin: SAP_CONSUMER_ORIGIN.PORTAL };
    }
    return config;
  });

  // Más información: https://github.com/axios/axios#interceptors
  instance.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (err) => {
      if (err?.response?.status === 401 && window.USER_ID) {
        return new Promise((_, reject) => {
          fetch(`${baseURL}${URLS.session}`, { method: 'GET', credentials: 'include' }).then((res) => {
            if (res?.status === 401) {
              window.location.href = `${ROUTE_PATH.SESSION_CLOSED}?noSplashScreen=1`;
            }
            reject(formatMessageError(err));
          });
        });
      }
      return Promise.reject(formatMessageError(err));
    },
  );

  return instance;
};

export default ApiFetch;
